import React, { Fragment, useRef } from 'react'
import ReactDatePicker from 'react-datepicker'
import { components } from 'react-select'

import styles from './DatePicker.module.scss'
import CalendarIcon from 'Icons/calendar.svg'

import ReactSelect from '../ReactSelect'
import * as date from 'Utils/date'

const NoRender = () => null

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props} className={styles.DropdownIndicator}>
      <CalendarIcon width='14' height='14' />
    </components.DropdownIndicator>
  )
}

const Picker = (props) => {
  const MenuPicker = (select) => {
    const { selectProps, setValue } = select

    const hiddenRef = useRef()

    const handleChange = (dates) => {
      const [start, end] = dates

      const value = [date.format(start, 'MM-DD-YYYY')]

      if (end) {
        value[1] = date.format(end, 'MM-DD-YYYY')
      }

      setValue(value)

      // patch for hiding the date picker when end value is selected
      if (end) {
        hiddenRef.current.focus()
      }
    }

    const selectedDate = selectProps.value || []

    const startDate = selectedDate[0] ? new Date(selectedDate[0]) : null
    const endDate = selectedDate[1] ? new Date(selectedDate[1]) : null

    return (
      <Fragment>
        <div className='hidden' contentEditable='true' ref={hiddenRef} />
        <ReactDatePicker
          {...props}
          inline
          selectsRange
          onChange={handleChange}
          calendarClassName={styles.Calander}
          startDate={startDate}
          endDate={endDate || null}
        />
      </Fragment>
    )
  }

  return MenuPicker
}

const Label = (props) => {
  const { value } = props.selectProps
  const [start, end] = value

  let formattedLabel = date.format(start, 'MM-DD-YYYY')

  if (end) {
    const startDate = new Date(start)
    const endDate = new Date(end)

    if (startDate.getFullYear() === endDate.getFullYear()) {
      formattedLabel = date.format(startDate, 'MM-DD')
    }

    formattedLabel += ' ~ '
    formattedLabel += date.format(end, 'MM-DD-YYYY')
  }

  return <components.SingleValue {...props}>{formattedLabel}</components.SingleValue>
}

const DateRangePicker = (props) => {
  const { value, onChange, ...datepickerProps } = props

  return (
    <ReactSelect
      className={styles.DatePickerSelect}
      isMulti={false}
      placeholder='Select Date Range'
      closeMenuOnSelect={false}
      isSearchable={false}
      isClearable
      value={value}
      onChange={onChange}
      components={{
        NoOptionsMessage: NoRender,
        SingleValue: Label,
        DropdownIndicator,
        MenuList: Picker(datepickerProps)
      }}
    />
  )
}

export default DateRangePicker
